import type { EditorPlugin } from '../../../types/aha-editor';
import FontFamilyMarkPlugin from './FontFamilyMarkPlugin';

const FontFamilyPlugin: EditorPlugin[] = [FontFamilyMarkPlugin];

export default FontFamilyPlugin;
